import { render } from "./secure-manage.vue?vue&type=template&id=6547cf5c"
import script from "./secure-manage.vue?vue&type=script&lang=js"
export * from "./secure-manage.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__